import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";

import "./index.scss";
import { GetQueryParam } from "@/utils/setting";
import Loading from "@/components/loading/index";
import Empty from "./empty";
import Result from "./result";
import Search from "../search";
import Store from "@/stores";

@observer
class LadderTarget extends Component {
	static propTypes = { _ladderStore: PropTypes.object }
	static defaultProps = { _ladderStore: {} }
	componentDidMount() {
		const btag = GetQueryParam("btag");
		const { getTarget } = Store._ladderStore;
		btag && getTarget(btag);
	}
	render() {
		const { target, targetLoading } = Store;
		if (targetLoading) return <Loading />;
		if (!target) return <Empty />;
		return (
			<div className="ladder-target">
				<div className="ladder-addition clearfix">
					<Search />
				</div>
				<Result />
			</div>
		);
	}
}
export default LadderTarget;